<template>
  <div v-if="value.meta">
    <el-divider />
      <h3>Additional Details</h3>
    <el-row :gutter="60">
      <!-- <el-col :span="24" :md="8">
        <el-input-title>Weapon</el-input-title>
        <el-form-item prop="meta.weapon">
          <el-select class="mt-05" @change="handleSelectWeapon" v-model="selectedWeapon">
            <el-option
              v-for="weapon in weapons"
              :key="weapon"
              :label="weapon"
              :value="weapon"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="8">
        <el-input-title>Hand Dominance</el-input-title>
        <el-form-item prop="meta.handDominance">
          <el-select class="mt-05" @change="handleSelectDominance" v-model="selectedHandDominance">
            <el-option
              v-for="{value, label} in [{value: 'Left', label: 'Left'}, {value: 'Right', label: 'Right'}]"
              :key="value"
              :label="label"
              :value="value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col> -->
      <!-- <el-col :span="24" :md="8">
        <el-input-title required>Home Club</el-input-title>
          <el-form-item prop="meta.homeClub">
            <el-select
              filterable
              remote
              reserve-keyword
              class="mt-05 w-100"
              v-model="selectedClubName.name"
              :remote-method="searchClub"
              @blur="refs.validateField('meta.homeClub')"
              @change="handleSelectHomeClub"
              placeholder="Select">
              <el-option
                v-for="item in clubs"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
      </el-col> -->
    </el-row>
    <el-row :gutter="60">
      <!-- Are you vaccinated? -->
      <!-- <el-col :span="24" :md="8" class="mt-20">
        <el-input-title required>School</el-input-title>
        <el-form-item prop="meta.volunteer">
          <el-input class="mt-05" v-model="value.meta.school" placeholder="School" />
        </el-form-item>
      </el-col> -->
      <el-col :span="24" :md="24" class="mt-20">
        <el-input-title required>Are you of Aboriginal and/or Torres Strait Islander origin?</el-input-title>
        <el-form-item prop="meta.isAboriginal">
          <el-select class="mt-05" v-model="value.meta.isAboriginal" placeholder="Yes / No">
            <el-option v-for="e in yesNoOptions" :label="e.name" :key="e.type" :value="e.name" />
          </el-select>
        </el-form-item>
      </el-col>
      <!-- <el-col :span="24" :md="24" class="mt-20">
        <el-input-title required>Would you like to subscribe to the NSWFA newsletter? (highly recommend, can unsubscribe any time)</el-input-title>
        <el-form-item prop="meta.newsOptOut">
          <el-select class="mt-05" v-model="value.meta.newsOptOut" placeholder="Yes / No">
            <el-option v-for="e in yesNoOptions" :label="e.name" :key="e.type" :value="e.type" />
          </el-select>
        </el-form-item>
      </el-col> -->
      <el-col :span="24" :md="24" class="mt-20">
        <el-input-title required>Would you consider volunteering once a year at least at NSWFA competitions or events?</el-input-title>
        <el-form-item prop="meta.volunteer">
          <el-select class="mt-05" v-model="value.meta.volunteer" placeholder="Yes / No">
            <el-option v-for="e in yesNoOptions" :label="e.name" :key="e.type" :value="e.type" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="24" class="mt-20">
        <el-input-title required>What kind of volunteering service (no experience required) may suit you?</el-input-title>
        <el-form-item prop="meta.volunteerType">
          <el-select class="mt-05" v-model="value.meta.volunteerType" placeholder="">
            <el-option v-for="e in volunteerOptions" :label="e" :key="e" :value="e" />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import playerDetails from '@/mixins/player-details';

export default {
  name: 'fencingnswExtra',
  mixins: [playerDetails],
  props: ['value', 'refs'],
  data() {
    return {
      yesNoOptions: [
        {
          name: 'Yes',
          type: true,
        },
        {
          name: 'No',
          type: false,
        }
      ],
      volunteerOptions: [
        'Canteen',
        'Safety supervision',
        'Competition DT assistance',
        'Equipment control',
        'Social media assistance',
        'Other'
      ],
      vaccinationShotOptions: [
        {
          name: 'Single shot',
          value: '1',
        },
        {
          name: 'Double shots',
          value: '2',
        },
        {
          name: 'Three shots',
          value: '3',
        },
        {
          name: 'More than three shots',
          value: '3+',
        },
      ],
      weapons: [
        'Sabre',
        'Foil',
        'Epee',
      ],
      selectedWeapon: '',
      selectedHandDominance: '',
      selectedClubName: '',
      clubs: []
    };
  },
  mounted() {
    if (this.value.meta && this.value.meta.homeClub) this.selectedClubName = this.value.meta.homeClub;
    if (this.value.meta && this.value.meta.weapon) this.selectedWeapon = this.value.meta.weapon;
    if (this.value.meta && this.value.meta.handDominance) this.selectedHandDominance = this.value.meta.handDominance;
    this.$http.post('/assemble/api/v1/portal/clubs/search', { criteria: '' }).then((res) => {
      const data = res.data.data.map((c) => ({ value: c.name, _id: c._id }));
      // Append none
      data.unshift({ value: 'None', _id: 'none' });
      this.clubs = data;
    }).catch(() => {});
  },
  methods: {
    handleVaccinationStatus() {
      if (!this.value.meta.vaccinated) {
        this.value.meta.vaccinationShot = '';
      }
    },
    handleSelectWeapon(selected) {
      this.value.meta.weapon = selected;
    },
    handleSelectDominance(selected) {
      this.value.meta.handDominance = selected;
    },
    handleSelectHomeClub(selected) {
      const club = this.clubs.find((c) => c.value === selected);
      this.selectedClubName = { name: club.value, _id: club._id };
      this.value.meta.homeClub = { name: club.value, _id: club._id };
    },
    searchClub(query) {
      this.$http.post('/assemble/api/v1/portal/clubs/search', { criteria: query }).then((res) => {
        const data = res.data.data.map((c) => ({ value: c.name, _id: c._id }));
        // Append none
        data.unshift({ value: 'None', _id: 'none' });
        this.clubs = data;
      }).catch(() => {});
    },
  }
};
</script>

<style lang="scss" scoped>

.el-autocomplete,
.el-select,
.el-input {
  width: 100%;
}

</style>
